const validate = (values) => {
    const errors = {};
  
    if (!values.behaviorCategoryName) {
      errors.behaviorCategoryName = 'Please enter behavior category name';
    }

    // if (!values.description) {
    //   errors.description = 'Please enter behavior category description';
    // }
   
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/validate.js